module.exports = __webpack_public_path__ + "img/suit-10.a8f47be2.png";